import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorHandlerInterceptor } from './interceptor/api.interceptor';
import { DatePipe } from '@angular/common';
import { provideNgIdle } from '@ng-idle/core';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),DatePipe , provideClientHydration(), provideHttpClient(withInterceptors([errorHandlerInterceptor])), 
  provideAnimations(),
  provideNgIdle(),
  provideToastr({
    timeOut: 4000,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
  }),
  ]
};
